import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { property as propertyCore } from '@breezeway/brzw-react-core';
import BasicConfirmModal from '../../confirm_modal/basic_confirm_modal';
import { propertyStatuses } from '../../../utils/property';

import './conflict_modal.scss';

const renderDialogBody = () => (
  <div className="conflict-modal">
    <p className="conflict-modal__subtitle">
      Your integration has this property marked{' '}
      <span className="conflict-modal__subtitle--warning">INACTIVE</span>
    </p>
    <p>
      Setting the property as inactive in Breezeway will prohibit you from assigning tasks at this
      property
    </p>
  </div>
);

class ConflictModal extends PureComponent {
  constructor(props) {
    super(props);

    this.onSetInactive = this.onSetInactive.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  onSetInactive() {
    const { property } = this.props;
    const id = _.get(property, 'id');
    const dataToSend = {
      home_ids: [id],
      type_property_status: propertyStatuses.inactive.code,
    };

    this.props.setPropertyStatus(dataToSend);
  }

  toggle(e) {
    _.invoke(e, 'preventDefault');
    _.invoke(e, 'stopPropagation');

    _.invoke(this.props, 'onClose');
  }

  render() {
    return (
      <BasicConfirmModal
        onToggle={this.toggle}
        onConfirm={this.onSetInactive}
        confirmButtonText="Set Inactive"
        title="Integrations status conflict"
        body={renderDialogBody()}
      />
    );
  }
}

ConflictModal.propTypes = {
  setPropertyStatus: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  onClose: PropTypes.func,
  property: PropTypes.shape({}),
};

const mapDispatchToProps = {
  setPropertyStatus: propertyCore.actions.setPropertyStatus,
};

export default connect(
  null,
  mapDispatchToProps,
)(ConflictModal);
